var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckLight = function SvgIconCheckLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_check_light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.575 17.58 21.878 32.178l-.002.001a2.299 2.299 0 0 1-1.626.696 2.3 2.3 0 0 1-1.657-.727l-7.6-8.2 1.614-1.496 7.581 8.18a.215.215 0 0 0 .057.04l.005.002c.001 0 .003 0 .005-.002a.233.233 0 0 0 .067-.05l.003-.003 14.7-14.6 1.55 1.562Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_check_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11 16)",
    d: "M0 0h25.6v16.9H0z"
  })))));
};
export default SvgIconCheckLight;